// stylelint-disable property-no-vendor-prefix
import styled from 'styled-components';

import { token } from '@zillow/constellation';

export const StyledContainer = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
  overflow: hidden;
`;

export const StyledFooterContainer = styled.div`
  background-color: ${token('colors.white')};
`;
